<template>
  <div class="dcp-filter-dropdown">
    <ui-dropdown :options="options" :value="value" :label="label" :disabled="disabled" @change="selectionChanged" />
  </div>
</template>
<script lang="ts">
import { DropdownOption } from '@dh-io-emh/ui/src/form/dropdown/dropdown.modal';
import UiDropdown from '@dh-io-emh/ui/src/form/dropdown/Dropdown.vue';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'EmhFilterDropdown',

  components: {
    UiDropdown,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array as PropType<Array<DropdownOption>>,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },

  emits: ['input'],

  setup(props, { emit }) {
    const selectionChanged = (newValue): void => {
      emit(
        'input',
        props.options.find((item) => item.value === newValue),
      );
    };

    return {
      selectionChanged,
    };
  },
});
</script>
<style src="./filterDropdown.scss" lang="scss"></style>
